module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/audienceheader/audienceheader.component.css
// module id = ./src/app/audienceheader/audienceheader.component.css
// module chunks = main